module.exports = __webpack_public_path__ + "img/Quironsalud.60f8bb35.png";